// extracted by mini-css-extract-plugin
module.exports = {"productName":"ProductName_productName__qWwW8","whiteLabeled":"ProductName_whiteLabeled__XnWIT"};